import Link from 'next/link';
import { IoBookmarksOutline } from 'react-icons/io5';

import { ActionIcon, Tooltip } from '@mantine/core';

import { SavedItemsHelpers } from 'helpers/SavedItemsHelpers';

const BookmarksButton = () => {
    return (
        <Tooltip label="My Bookmarks" offset={10}>
            <ActionIcon
                component={Link}
                href={SavedItemsHelpers.urls.overview()}
                variant="subtle"
                radius={99}
                size="lg"
                style={{ overflow: 'visible' }}
            >
                <IoBookmarksOutline size={20} />
            </ActionIcon>
        </Tooltip>
    );
};

export { BookmarksButton };
